import { PrimaryButtonsSlotPlacement as BasicPrimaryButtonsSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const PrimaryButtonsSlotPlacement = withEditorSlotsState(
  BasicPrimaryButtonsSlotPlacement,
);
